module.exports = __webpack_public_path__ + "7255c45667612987a064fb3bf0885e1f.png";